import { render } from "./groupsPage.vue?vue&type=template&id=64d47ca8"
import script from "./groupsPage.vue?vue&type=script&lang=js"
export * from "./groupsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__